/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Withdraw destination.
 */
export interface WithdrawInfoDto {
  /**
   * Unique address ID for withdrawal request.
   */
  id: number;
  /**
   * Address.
   */
  address: string;
  /**
   * Network.
   */
  network: string;
  /**
   * Contract if exists.
   */
  contract?: string;
  /**
   * Tag.
   */
  tag?: string;
}
